/* eslint-disable */
import { IState } from "@/interfaces/IState";
import { IModal } from "@/interfaces/modal/IModal";

export const modal = {
  state: {
    dialog: false,
  },
  mutations: {
    OPEN_CLOSE(state: IState, payload: IModal) {
      state.dialog = payload.dialog;
    },
  },
  actions: {
    openCloseModal(context: any, payload: IModal) {
      context.commit("OPEN_CLOSE", payload);
    },
  },
  getters: {
    getDialogModal(state: IState) {
      return state.dialog;
    },
  },
};
